// react
import styled from 'styled-components';

// components
import { Button, Container, Logo, TextIcon } from '@/components/atoms';
import {
  GenericFlowProps,
  OnboardingActions,
  OnboardingActionType,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';
import { FloatingWithHeroTemplate } from '@/components/templates';

// assets
// @transform-path ../../../../../../src/assets/referral/header.jpg
import hero from '@/assets/referral/header.jpg';

/**
 * OnboardingHero renders the Hero screen for onboarding flows.
 */
export const OnboardingHero = toGenericOnboarding(
  ({
    config,
    currentIndex = 0,
    handleClick,
  }: GenericFlowProps<OnboardingHeroConfigItem>) => {
    return (
      <FloatingWithHeroTemplate
        content={
          <Container size='md'>
            <ContentContainer>
              <LogoContainer>
                <Logo size='lg' />
              </LogoContainer>
              <div>
                <GreetingTitle>{config[currentIndex]?.title}</GreetingTitle>
                <TextWrapper>
                  {config[currentIndex]?.text1 && (
                    <TextIcon
                      text={config[currentIndex]?.text1}
                      centerText={!config[currentIndex]?.text2}
                      showIcon={!!config[currentIndex]?.text2}
                    />
                  )}
                  {config[currentIndex]?.text2 && (
                    <TextIcon
                      text={config[currentIndex]?.text2}
                      centerText={false}
                      showIcon={true}
                    />
                  )}
                  {config[currentIndex]?.text3 && (
                    <TextIcon
                      text={config[currentIndex]?.text3}
                      centerText={false}
                      showIcon={true}
                    />
                  )}
                </TextWrapper>
              </div>
              <Button
                ariaLabel={config[currentIndex]?.ctaButtonLabel}
                onPress={() => handleClick?.(OnboardingActionType.Next)}
              >
                {config[currentIndex]?.ctaButtonLabel}
              </Button>
            </ContentContainer>
          </Container>
        }
        hero={
          <HeroContainer>
            <img src={hero} alt='hero' />
          </HeroContainer>
        }
      />
    );
  },
);

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ContentContainer = styled.div`
  padding: 0 ${(props) => props.theme.spacing[12]};
  box-sizing: border-box;

  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
`;

const GreetingTitle = styled.div`
  font: ${(props) => props.theme.typography.heading['6xl']};
  color: ${(props) => props.theme.color.primary[80]};
  margin-bottom: ${(props) => props.theme.spacing[48]};
  text-align: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
`;

const HeroContainer = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 16px;
  height: 100%;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export interface OnboardingHeroConfigItem extends OnboardingActions {
  id: string;
  title: string;
  text1: string;
  text2: string;
  text3: string;
  ctaButtonLabel: string;
}

OnboardingHero.displayName = 'OnboardingHero';
export default toGenericOnboarding(OnboardingHero);
